import * as yup from "yup";

export const clientSchema = yup.object().shape({
  name: yup.string().required("Esse campo é obrigatório"),
  cnpj: yup.string().required("Esse campo é obrigatório"),
});
